var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPieChart = function SvgPieChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "pie-chart_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.21 15.89A10 10 0 1 1 8 2.83",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.239 8.173A10 10 0 0 1 22 12H12V2a10 10 0 0 1 9.239 6.173Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgPieChart as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMjEuMjA5OSAxNS44OUMyMC41NzM3IDE3LjM5NDQgMTkuNTc4NyAxOC43MjAyIDE4LjMxMTggMTkuNzUxM0MxNy4wNDQ5IDIwLjc4MjMgMTUuNTQ0NyAyMS40ODc0IDEzLjk0MjQgMjEuODA0N0MxMi4zNCAyMi4xMjIxIDEwLjY4NDMgMjIuMDQyMSA5LjEyMDA2IDIxLjU3MThDNy41NTU3OCAyMS4xMDE0IDYuMTMwNTQgMjAuMjU1IDQuOTY4OTMgMTkuMTA2NkMzLjgwNzMzIDE3Ljk1ODIgMi45NDQ3MyAxNi41NDI3IDIuNDU2NTUgMTQuOTgzOUMxLjk2ODM3IDEzLjQyNTEgMS44Njk0OCAxMS43NzA0IDIuMTY4NTEgMTAuMTY0NkMyLjQ2NzU1IDguNTU4NzQgMy4xNTU0MSA3LjA1MDU4IDQuMTcxOTYgNS43NzE5OUM1LjE4ODUxIDQuNDkzMzkgNi41MDI4IDMuNDgzMjcgNy45OTk5MiAyLjgyOTk2IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48cGF0aCBkPSJNMjEuMjM4OCA4LjE3MzE3QzIxLjc0MTMgOS4zODY0MiAyMiAxMC42ODY4IDIyIDEySDEyVjJDMTMuMzEzMiAyIDE0LjYxMzYgMi4yNTg2NiAxNS44MjY4IDIuNzYxMkMxNy4wNDAxIDMuMjYzNzUgMTguMTQyNSA0LjAwMDM1IDE5LjA3MTEgNC45Mjg5M0MxOS45OTk3IDUuODU3NTIgMjAuNzM2MiA2Ljk1OTkxIDIxLjIzODggOC4xNzMxN1oiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==";